import React, { useState, useEffect } from 'react';
import { LOGO_URL, NAV_LINKS, COMPANY } from '../data/mockData';
import { Menu, X, MessageSquare } from 'lucide-react';

const Navbar = ({ onEnquireClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg shadow-black/20'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#home" onClick={() => handleNavClick('#home')} className="flex items-center gap-3 flex-shrink-0">
            <img
              src={LOGO_URL}
              alt={COMPANY.name}
              className="h-14 w-auto object-contain"
            />
          </a>

          {/* Desktop Nav Links */}
          <div className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <button
                key={link.label}
                onClick={() => handleNavClick(link.href)}
                className="text-sm font-medium text-gray-300 hover:text-[#DAA520] transition-colors duration-200 tracking-wide"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-3">
            <button
              onClick={onEnquireClick}
              className="flex items-center gap-2 px-5 py-2.5 border border-[#DAA520] text-[#DAA520] rounded-sm text-sm font-semibold tracking-wider hover:bg-[#DAA520] hover:text-black transition-all duration-300"
            >
              <MessageSquare size={16} />
              ENQUIRE NOW
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden text-white p-2"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-[#0a0a0a]/95 backdrop-blur-md border-t border-gray-800 px-4 py-4 space-y-3">
          {NAV_LINKS.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className="block w-full text-left text-gray-300 hover:text-[#DAA520] py-2 text-sm font-medium tracking-wide transition-colors"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => {
              setMobileOpen(false);
              onEnquireClick();
            }}
            className="w-full flex items-center justify-center gap-2 px-5 py-2.5 border border-[#DAA520] text-[#DAA520] rounded-sm text-sm font-semibold tracking-wider hover:bg-[#DAA520] hover:text-black transition-all duration-300 mt-2"
          >
            <MessageSquare size={16} />
            ENQUIRE NOW
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
